













import { Component, Vue } from 'vue-property-decorator'
import { inject } from 'inversify-props'
import { IProjectSettings } from '@master/config/IProjectSettings'

@Component
export default class Admin extends Vue {
  @inject()
  private projectSettings: IProjectSettings

  get currentUser () {
    return this.$store.getters.currentUser
  }

  get menus () {
    return [
      {
        label: 'Agent Codes Mass Update',
        url: '/agent-codes-mass-update',
        img: require('@core/assets/admin/Agent Codes Mass Update.png')
      },
      {
        label: 'Assumptions List',
        url: '/admin-assumptions',
        img: require('@core/assets/admin/Assumptions List.png'),
        disable: !this.projectSettings.useAssumptionsList
      },
      {
        label: 'BSC Module',
        url: '/bsc-home',
        img: require('@core/assets/admin/BSC Module.png')
      },
      {
        label: 'CMS',
        url: '/client-management',
        img: require('@core/assets/admin/CMS.png')
      },
      {
        label: 'Commission Module',
        url: '/commission-module',
        img: require('@core/assets/admin/Commission Module.png')
      },
      {
        label: 'CPD',
        url: '/cpd/summary',
        img: require('@core/assets/admin/CPD.png')
      },
      {
        label: 'Group Administration',
        url: '/group-list',
        img: require('@core/assets/admin/Group Administration.png')
      },
      {
        label: 'Intermediaries List',
        url: '/payee-list',
        img: require('@core/assets/admin/Intermediaries List.png')
      },
      {
        label: 'Product List',
        url: '/admin-products',
        img: require('@core/assets/admin/Product List.png')
      },
      {
        label: 'Product Principal List',
        url: '/company-codes-list',
        img: require('@core/assets/admin/Product Principal List.png')
      },
      {
        label: 'Resources',
        url: '/resources',
        img: require('@core/assets/admin/Resources.png'),
        disable: !this.projectSettings.useResourcesModule
      },
      {
        label: 'Sales Team Administration',
        url: '/sales-team-administration',
        img: require('@core/assets/admin/Sales Team Administration.png'),
        disable: !this.projectSettings.useSalesTeamAdmin
      },
      {
        label: 'Survey',
        url: '/admin-survey',
        img: require('@core/assets/admin/Product List.png'),
        disable: !this.projectSettings.useKycSurvey
      },
      {
        label: 'User Administration',
        url: '/user-list',
        img: require('@core/assets/admin/User Administration.png')
      }
    ]
  }
}
